import router from "./router";
import Vue from "vue";
import App from "./App";
import store from "./store";
import "bootstrap3";
import titleMixin from "./mixins/title";
import AsyncComputed from "vue-async-computed";
import Vue2Editor from "vue2-editor";
import "quill-mention";
import ApiService from "./common/api.service";
import { Plugin } from "vue-fragment";
import Toasted from "vue-toasted";
import VTooltip from "v-tooltip";
import VueNumeric from "vue-numeric";
import AudioRecorder from "vue-audio-recorder";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import moment from "moment";
import Autocomplete from "v-autocomplete";
import "v-autocomplete/dist/v-autocomplete.css";
import "quill-mention/dist/quill.mention.css";
import TextareaAutosize from "vue-textarea-autosize";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";

Vue.use(Autocomplete);
Vue.component("vue-bootstrap-typeahead", VueBootstrapTypeahead);
Vue.use(AudioRecorder);
Vue.use(VueNumeric);
Vue.use(VTooltip);
Vue.use(Toasted);
Vue.mixin(titleMixin);
Vue.config.productionTip = false;
Vue.use(AsyncComputed);
Vue.use(Plugin);
Vue.use(Vue2Editor);
Vue.use(TextareaAutosize);
Vue.use(FloatingVue);
Vue.filter("dateFormat", function(value) {
  if (!value) return "";
  return moment(value).format("DD.MM.YYYY");
});

const requireComponent = require.context("./components/project/form", false);
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);
  const componentName = fileName
    .split("/")
    .pop()
    .replace(/\.\w+$/, "");
  Vue.component(
    componentName,
    // Поиск опций компонента в `.default`, который будет существовать,
    // если компонент экспортирован с помощью `export default`,
    // иначе будет использован корневой уровень модуля.
    componentConfig.default || componentConfig
  );
});

ApiService.init();

/*
router.beforeEach((to, from, next) =>
  Promise.all([store.dispatch(CHECK_AUTH)]).then(next)
);
*/

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
